import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  NatsConnection,
  StringCodec,
  connect,
  Subscription
} from "nats.ws"

@Injectable({
  providedIn: 'root'
})
export class NatService {
  private nc?: NatsConnection
  private sc = StringCodec()

  async connect() {
    this.nc = await connect({
      servers: environment.NATS.URL,
      user: environment.NATS.USERNAME,
      pass: environment.NATS.PASSWORD,
    })
    console.log('[NATS] Conectado')
  }

  async subscribe(topic: string, callback: (msg: string) => void) {
    if(!this.nc) return;

    const sub: Subscription = this.nc.subscribe(topic)

    for await (const m of sub) {
      callback(this.sc.decode(m.data))
    }
  }

  async publish(topic: string, message: string) {
    if (!this.nc) return;
    this.nc.publish(topic, this.sc.encode(message))
  }

  async disconnect() {
    await this.nc?.drain();
    console.log('[NATS] Desconectado;')
  }
}
